import _ from '@lodash';
import React, { useState } from 'react';
import { TableCell, Tooltip, IconButton, Icon } from '@material-ui/core';
import GetApp from '@material-ui/icons/GetApp';
import nBossConnection from 'modules/base/service/nBossConnection';

function MeasurementDownloadButton(props) {
	const download = () => {
		console.log('dl');
	};

	return (
		<TableCell className="text-center" padding="none">
			<Tooltip title="Download">
				<IconButton
					// component="a"
					colorSecondary
					href={props.item && props.item.id !== null ? `${nBossConnection.baseUrl}measurementTableControl/downloadCsv?id=${props.item.id}` : null}
				// target="_blank"
				// aria-label="download"
				// download
				>
					<GetApp fontSize="small" className='opacity-50' style={{ fill: 'inherit' }} />
				</IconButton>
			</Tooltip>
		</TableCell>
	);
}

export default MeasurementDownloadButton;
